import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const loginStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            minHeight: "100vh",
        },

        sideImage: {
            backgroundImage: "url(images/LandingImage.png)",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "bottom right",
        },

        formContainer: {
            padding: "65px 16px 16px 16px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            height: "100vh",
        },

        logo: {
            width: 298,
            height: 85,
            marginBottom: "45px",
        },

        title: {
            fontWeight: 400,
            marginBottom: 41,
        },

        copyright: {
            marginTop: "auto",
        },

        indicatorContainer: {
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        },
    })
);
